import { Banner, DataGrid } from '@if/mui'
import { useRecentCommandHistory } from '@src/api/dev-tools-history-api'
import { DevToolsCommandType } from '@src/types/dev-tools'
import { useTranslation } from 'react-i18next'
import { useCommandHistoryColumns } from './CommandHistoryColumns'

interface CommandRecentExecutionsTableProps {
  commandType: DevToolsCommandType
}

const RECENT_EXECUTIONS_LIMIT = 5

/**
 * The last five runs of one command. Card mode is off: the table is half a card wide at
 * every size, so stacking its three fields would only make it taller.
 */
const CommandRecentExecutionsTable = ({ commandType }: CommandRecentExecutionsTableProps) => {
  const { t } = useTranslation()
  const columns = useCommandHistoryColumns({ includeErrorMessage: false })
  const { data, isLoading, isError } = useRecentCommandHistory(commandType, RECENT_EXECUTIONS_LIMIT)

  if (isError) {
    return <Banner severity="error">{t('admin.devTools.history.loadError')}</Banner>
  }

  return <DataGrid rows={data ?? []} columns={columns} loading={isLoading} paginated={false} cardBelow={false} dense />
}

export default CommandRecentExecutionsTable
